export const PROJECT_VERSION = process.env.REACT_APP_PROJECT_VERSION ?? '0.0.0';
export const BUILD_DATETIME = process.env.REACT_APP_BUILD_DATETIME ?? 'unknown';

export const CLIENT_COMPANY = "Carbez";
export const DEVELOPED_BY = "Clicktap Digital";

export const PROPERTY_FOR_OPTIONS = [
  { label: "Rent", value: "rent" },
  { label: "Sale", value: "sale" },
];

export const PROPERTY_TYPE_OPTIONS = [
  { label: "Modular Home", value: "modular home" },
  { label: "Apartment", value: "apartment" },
  { label: "Villa", value: "villa" },
];

export const ACCESS_TYPE_OPTIONS = [
  { label: "Select Role", value: "" },
  { label: "Admin", value: "admin" },
  { label: "Super Admin", value: "superadmin" },
];

export const JOB_TYPE_OPTIONS = [
  { label: "Full Time", value: "Full Time" },
  { label: "Part Time", value: "Part Time" },
];

export const JOB_CATEGORY_OPTIONS = [
  { label: "Digital Marketing", value: "Digital Marketing" },
  { label: "Developer", value: "Developer" },
];